import { Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import SendDocument from './SendDocument';
import './UploadDocument.scss';
import { useTranslation } from 'react-i18next';
import { BackAvatarSVG } from '../../img/GlobalSVG';
import useUploadDocument from './hooks/useUploadDocument';
import { useDispatch } from 'react-redux';
import { resetUploadDocuments } from 'src/redux/admin/uploadDocumentSlice';
import { ToastContainer } from 'react-toastify';

const UploadDocument = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const { state } = location;
  const { onClickViewButton } = useUploadDocument(state.userSpecDoc);

  console.log('selectedTabDocument', state.userSpecDoc, location?.state);

  dispatch(resetUploadDocuments());
  return (
    <div>
      <Row className="d-flex justify-content-between align-items-center mb-4 document-heading-container">
        <Col md={8} sm={6} lg={6}>
          <div className="d-flex align-items-center">
            <div>
              <button
                onClick={onClickViewButton}
                className="send-document-backarrow border-0 bg-transparent"
              >
                <BackAvatarSVG.BackArrowSVG />
              </button>
            </div>
            <div className="ml-2">
              <h1 id="greetings-time" aria-hidden={true}>
                Send <span className="content-header-bold">Document(s)</span>
              </h1>
            </div>
          </div>
        </Col>
        <Col md={4} sm={6} lg={6} className="button-class mt-2">
          <button
            onClick={onClickViewButton}
            className="border-0 bg-transparent"
            role="button"
            aria-label="Click View All button to go to documents list page"
          >
            <GenericButton variant="primary" tabIndex={-1}>
              {t('member.upload_document.view_all')}
            </GenericButton>
          </button>
        </Col>
      </Row>
      <SendDocument
        userSpecDoc={state.userSpecDoc ? state.userSpecDoc : false}
      />
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

export default UploadDocument;
